const checkboxTokens = ({
  borders,
  colors,
  colorsBrand,
  space,
  lineHeights,
  fontSizeBody,
}) => ({
  borders: borders[2],
  colors: {
    labelColor: colors.neutrals[2],
    hover: {
      default: colors.neutrals[4],
      variant: colors.positive.dark,
    },
    default: {
      borderColor: colors.neutrals[5],
      iconColor: colors.white,
      bgColor: colors.white,
    },
    checked: {
      borderColor: colors.neutrals[5],
      iconColor: colorsBrand[1],
      bgColor: colors.white,
    },
    error: {
      borderColor: colors.negative.default,
      iconColor: colors.negative.default,
      bgColor: colors.negative.lightest,
      labelColor: colors.critical.default,
    },
    disabled: {
      borderColor: colors.neutrals[5],
      iconColor: colors.neutrals[2],
      bgColor: colors.white,
    },
    variant: {
      borderColor: colors.positive.dark,
      iconColor: colors.white,
      bgColor: colors.positive.dark,
    },
  },
  space: {
    fromLabel: space['1x_small'],
  },
  sizes: {
    minWidth: '20px',
    height: '20px',
  },
  lineHeight: lineHeights.body,
  fontSizes: fontSizeBody[1],
  opacity: {
    disabled: 0.4,
  },
});

export default checkboxTokens;
